import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    bonusReportKey,
    bpiStatusColumnKey,
    closedColumnKey,
    closedPositionKey,
    closedPositionsTitle,
    closedStockPriceColumnKey,
    fiveStarModelPortfolioKey,
    initiatedColumnKey,
    initiatedKey,
    lastCloseColumnKey,
    marketRelativeStrengthColumnKey,
    noteColumnKey,
    openedPositionKey,
    openedStockPriceColumnKey,
    openPositionsTitle,
    peerRelativeStrengthColumnKey,
    positionSizeCalculatorKey,
    sectorColumnKey,
    sectorRelativeStrengthColumnKey,
    sectorSpotlightKey,
    sfLessonsKey,
    sfProductKey,
    stanceColumnKey,
    stockGainsColumnKey,
    symbolColumnKey,
    tradeAlertKey,
    webinarKey
} from "@/types/products/product-definitions";
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";


const initialView: string = fiveStarModelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: sfProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                stanceColumnKey,
                lastCloseColumnKey,
                sectorColumnKey,
                bpiStatusColumnKey,
                sectorRelativeStrengthColumnKey,
                peerRelativeStrengthColumnKey,
                marketRelativeStrengthColumnKey,
                initiatedColumnKey,
                openedStockPriceColumnKey,
                noteColumnKey,
                actionsColumnKey
            ]
        },
        {
            key: closedPositionKey,
            title: closedPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                sectorColumnKey,
                initiatedColumnKey,
                closedColumnKey,
                openedStockPriceColumnKey,
                closedStockPriceColumnKey,
                stockGainsColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    bonusReportKey,
    fiveStarModelPortfolioKey,
    tradeAlertKey,
    sectorSpotlightKey,
    webinarKey,
    sfLessonsKey,
    positionSizeCalculatorKey
];

export function useSectorFocus() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( sfProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'SF', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
